import { useEffect, useState } from 'react'
import { MeshGradient } from '@paper-design/shaders-react'
import './App.css'

function App() {
  const [isVisible, setIsVisible] = useState(false)
  const [demoState, setDemoState] = useState<'idle' | 'holding' | 'speaking' | 'done'>('idle')
  const [demoText, setDemoText] = useState('')

  useEffect(() => {
    setIsVisible(true)
  }, [])

  useEffect(() => {
    const runDemo = () => {
      setDemoState('idle')
      setDemoText('')
      setTimeout(() => setDemoState('holding'), 1200)
      setTimeout(() => setDemoState('speaking'), 2000)
      setTimeout(() => {
        setDemoState('done')
        const text = 'hello, world'
        let i = 0
        const typeInterval = setInterval(() => {
          if (i <= text.length) {
            setDemoText(text.slice(0, i))
            i++
          } else {
            clearInterval(typeInterval)
          }
        }, 50)
      }, 3800)
    }
    runDemo()
    const interval = setInterval(runDemo, 9000)
    return () => clearInterval(interval)
  }, [])

  return (
    <main className={`eva ${isVisible ? 'visible' : ''}`}>
      {/* Shader background */}
      <div className="eva__shader">
        <MeshGradient
          colors={[
            '#000411',
            '#0a0714',
            '#160c28',
            '#efcb68',
            '#d4b35c',
            '#000411',
          ]}
          speed={0.2}
          scale={1.2}
          distortion={0.4}
          swirl={0.3}
          grainMixer={0.12}
          grainOverlay={0.06}
        />
      </div>

      {/* Gradient overlay */}
      <div className="eva__overlay" aria-hidden="true" />

      <div className="eva__content">
        {/* Hero */}
        <header className="eva__hero">
          <div className="eva__logo-wrap">
            <img src="/eva-logo.svg" alt="" className="eva__logo" />
          </div>
          <h1 className="eva__title">eva</h1>
          <p className="eva__subtitle">Voice to text, locally.</p>
        </header>

        {/* Demo visualization */}
        <div className="eva__demo">
          <div className={`eva__step ${demoState === 'holding' || demoState === 'speaking' ? 'active' : ''}`}>
            <div className="eva__key">
              <span>fn</span>
            </div>
            <span className="eva__step-label">hold</span>
          </div>

          <div className="eva__connector">
            <div className={`eva__connector-line ${demoState === 'speaking' || demoState === 'done' ? 'active' : ''}`} />
          </div>

          <div className={`eva__step ${demoState === 'speaking' ? 'active' : ''}`}>
            <div className="eva__waves">
              <i /><i /><i />
            </div>
            <span className="eva__step-label">speak</span>
          </div>

          <div className="eva__connector">
            <div className={`eva__connector-line ${demoState === 'done' ? 'active' : ''}`} />
          </div>

          <div className={`eva__step ${demoState === 'done' ? 'active' : ''}`}>
            <div className="eva__output">
              <span className="eva__output-text">{demoText || '...'}</span>
              <span className="eva__caret" />
            </div>
            <span className="eva__step-label">done</span>
          </div>
        </div>

        {/* Features */}
        <div className="eva__features">
          <div className="eva__feature">
            <span className="eva__feature-icon">⚡</span>
            <span className="eva__feature-text">Local & Private</span>
          </div>
          <div className="eva__feature-divider" />
          <div className="eva__feature">
            <span className="eva__feature-icon">∞</span>
            <span className="eva__feature-text">Free Forever</span>
          </div>
          <div className="eva__feature-divider" />
          <div className="eva__feature">
            <span className="eva__feature-icon">◎</span>
            <span className="eva__feature-text">One Key</span>
          </div>
        </div>

        {/* CTA */}
        <div className="eva__cta">
          <a href="https://downloads.kolam.ai/eva.dmg" className="eva__download" download>
            <svg className="eva__download-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download for Mac
          </a>
          <span className="eva__req">macOS 14.0+</span>
        </div>
      </div>

      <footer className="eva__footer">
        <span>© {new Date().getFullYear()} Kolam AI</span>
      </footer>
    </main>
  )
}

export default App
